
export class ActivateService {
    
}


// WEBPACK FOOTER //
// ./src/app/public/activate/activate.service.ts